export enum EConfirmationModalIcons {
  Check = 'check',
  Cross = 'cross',
  None = 'none',
  Trash = 'trash',
}
